/* ig-enquire.js  v1  2026-08-27
   "Contact our sales team" panel for made-to-order sizes.

   Larry, 27 Aug: "Nobody can buy 6+, but we add the description saying contact
   our sales."

   Every 6ct-and-above variant across the seven rings that offer one is now set
   to 0 stock with inventory policy DENY, so Shopify blocks the sale by itself.
   Left alone the theme would simply say SOLD OUT, which is the wrong message -
   the stone is not sold out, it is sourced to order. This replaces that button
   with an explanation and a route to the sales team.

   Trigger is the OPTION VALUE, not a product list: any selected option matching
   /or above|contact us/ switches the panel on. So it will pick up any future
   product that uses the same convention with no code change.

   Runs on ALL viewports - a desktop buyer needs this message just as much.
   The panel and its styles are injected by this file, so it is one asset with
   no CSS partner.

   REVERT: delete this file and remove its <script> from snippets/preload.liquid.
   Nothing in the theme's own markup is modified - only inline display toggling
   that is undone the moment a normal size is selected. */
(function () {
  'use strict';

  var LINK = '/pages/contact';
  var RE = /or above|contact us/i;
  var COPY = 'Diamonds of 6ct and above are sourced and made to order. Our sales team will confirm availability, certification and the final price with you.';

  var panel = null;
  var hidden = [];
  var styled = false;

  function selectedEnquiry() {
    var sels = document.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < sels.length; i++) if (RE.test(sels[i].value || '')) return true;
    var rads = document.querySelectorAll('.product-form input[type=radio]:checked');
    for (var j = 0; j < rads.length; j++) if (RE.test(rads[j].value || '')) return true;
    return false;
  }

  function injectStyle() {
    if (styled) return;
    styled = true;
    var s = document.createElement('style');
    s.textContent =
      '.ig-enq{display:none;margin:16px 0;padding:16px;border:1px solid #192B54;border-radius:6px;background:#F6F7FA}' +
      'body.ig-enquire-on .ig-enq{display:block}' +
      '.ig-enq__t{margin:0 0 12px;font-size:14px;line-height:1.55;color:#192B54}' +
      '.ig-enq__b{display:block;padding:14px 16px;background:#192B54;color:#fff;font-size:12px;' +
      'letter-spacing:.09em;text-transform:uppercase;text-align:center;text-decoration:none;border-radius:4px}' +
      '.ig-enq__b:hover{opacity:.9;color:#fff}';
    (document.head || document.documentElement).appendChild(s);
  }

  function build() {
    if (panel && panel.isConnected) return true;

    var atc = document.querySelector('input.add-to-cart-btn, .add-to-cart-btn, button[name="add"], input[name="add"]');
    if (!atc) return false;

    /* .qty_addtocart_btns holds the quantity stepper AND the add-to-cart button.
       Falling back to the button alone keeps this safe if the theme changes. */
    var host = atc.closest('.qty_addtocart_btns') || atc.closest('.product_page_addtocart') || atc;
    if (!host.parentNode) return false;

    injectStyle();

    panel = document.createElement('div');
    panel.className = 'ig-enq';

    var p = document.createElement('p');
    p.className = 'ig-enq__t';
    p.textContent = COPY;

    var a = document.createElement('a');
    a.className = 'ig-enq__b';
    a.href = LINK;
    a.textContent = 'Contact our sales team';

    panel.appendChild(p);
    panel.appendChild(a);
    host.parentNode.insertBefore(panel, host);

    hidden = [host];
    var pay = document.querySelector('.shopify-payment-button');
    if (pay) hidden.push(pay);
    return true;
  }

  function sync() {
    if (!build()) return;
    var on = selectedEnquiry();
    document.body.classList.toggle('ig-enquire-on', on);
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].style.display = on ? 'none' : '';
    }
  }

  function init() {
    sync();
    document.addEventListener('change', function () { setTimeout(sync, 60); }, true);
    document.addEventListener('click', function () { setTimeout(sync, 150); }, true);
    [400, 900, 1600].forEach(function (ms) { setTimeout(sync, ms); });
    if (window.MutationObserver) {
      var host = document.querySelector('.main__product-inner') || document.body;
      new MutationObserver(function () { sync(); }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', sync);
}());
